export const PAGE_CHANGE = 'PAGE_CHANGE';
export const ROUTE_CHANGE = 'ROUTE_CHANGE';
export const EY_DELIVERS = 'EYDelivers';
export const EY_PRODUCTS = 'EYDelivers';

export const getEnvironment = value => {
  if (value === 'production') {
    return 'PROD';
  } else if (value === 'test') {
    return 'QA';
  } else {
    return 'DEV';
  }
};



// WEBPACK FOOTER //
// ./src/metrics/metricsConstants.js